<template>
  <div>
    <Card>
      <Card dis-hover :bordered="false">
        <Form :label-width="100">
          <Row>
            <Col :span="6">
              <FormItem label="区县">
                <Select transfer v-model="countyId" @on-change="getDutySignRecordss" clearable
                        @on-clear.once="getDutySignRecordss">
                  <Option v-for="(item,index) in countyList" :key="index" :value="item.indexCode"
                          :label="item.name"></Option>
                </Select>
              </FormItem>
            </Col>
            <Col :span="6">
              <FormItem label="日期">
                <DatePicker style="width: 100%" type="month" v-model="dutyCalendarDate" clearable placeholder="选择日期"
                            @on-change="getDutySignRecordss"
                            @on-clear="getDutySignRecordss('clear')" transfer></DatePicker>
              </FormItem>
            </Col>

            <Col :span="2" style="text-align: right;">
              <Button code="sign.export" type="primary" @click="exportCalender" :loading="exportLoading">导出</Button>
            </Col>
          </Row>
        </Form>
      </Card>
      <Table
        :loading="dataLoading"
        :columns="columns"
        :data="data"
        :border="false"
        :stripe="false"
        :span-method="handleSpan"
        :highlight-current-row="true"
      >
        <template #action="{ row, index }">
          <!--          <el-button :disabled="row.status === '1'" size="small" type="text" @click="editNews(row)">编辑</el-button>-->
          <!--          <el-button :disabled="row.status === '1'" size="small" type="text" @click="releaseNews(row, 1)">发布</el-button>-->
          <!--          <el-button size="small" type="text" @click="gotoDetail(row)">查看</el-button>-->
          <!--          <el-button :disabled="row.createUser !== curUser" size="small" type="text" @click="deleteNews(row)">删除</el-button>-->
        </template>
      </Table>
      <Page style="text-align: right;margin-top: 10px"
            show-sizer
            show-total
            transfer
            :total="dataTotal"
            :page-size="pageSize"
            :page-size-opts="pageSizeOpts"
            :current-page="currentPage"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
      ></Page>
    </Card>
  </div>
</template>

<script>
import moment from 'moment/moment'

export default {
  name: "signRecord",
  data() {
    return {
      dutyCalendarDate: new Date(),
      dataLoading: false,
      exportLoading: false,
      dataTotal: 0,
      countyList: [],
      countyId: '',
      columns: [
        {
          title: '值班日期',
          key: 'dutyDate',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', moment(params.row.dutyDate).format('YYYY-MM-DD'))
            ])
          }
        },
        // {title: '区县', key: 'countyName', align: 'center'},
        // {title: '值班类型', key: 'post', align: 'center'},
        {title: '值班类型', align: 'center', key: 'post'},
        {title: '值班人员', key: 'dutyPersonnel', align: 'center'},
        {title: '签到人员', key: 'signUser', align: 'center'},
        {
          title: '签到时间', key: 'signTime', align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', params.row.signTime === null ? '' : moment(params.row.signTime).format('YYYY-MM-DD HH:mm:ss'))
            ])
          }
        },
        {title: '签退人员', align: 'center', key: 'signOutUser'},
        {
          title: '签退时间', align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', params.row.signOutTime === null ? '' : moment(params.row.signOutTime).format('YYYY-MM-DD HH:mm:ss'))
            ])
          }
        },
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1,
      curUser: '',
    }
  },
  watch: {
    userInfo: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          console.log(newVal)
          this.curUser = newVal.userId
        }
      }
    }
  },
  computed: {
    userInfo: {
      get: function () {
        return this.$store.state.user.userInfo
      },
      set: function () {
      }
    }
  },
  mounted() {
    this.getCountyList()

  },
  methods: {
    handleSpan({ row, column, rowIndex, columnIndex }) {
      //合并第二列,这里columnIndex===1 根据具体业务来，比如本示例中需要合并的name为第二列
      if (columnIndex === 0) {
        //计算合并的行数列数
        let x = row.mergeCol === 0 ? 0 : row.mergeCol;
        let y = row.mergeCol === 0 ? 0 : 1;
        return [x, y];
      }
    },
    formatData(data) {
      let names = [];
      //筛选出不重复的 name值,将其放到 names数组中
      data.forEach((e) => {
        if (!names.includes(e.dutyDate)) {
          names.push(e.dutyDate);
        }
      });

      let nameNums = [];
      //将names数组中的 name值设置默认合并0个单元格,放到 nameNums中
      names.forEach((e) => {
        nameNums.push({ dutyDate: e, num: 0 });
      });

      //计算每种 name值所在行需要合并的单元格数
      data.forEach((e) => {
        nameNums.forEach((n) => {
          if (e.dutyDate === n.dutyDate) {
            n.num++;
          }
        });
      });

      //将计算后的合并单元格数整合到 data中
      data.forEach((e) => {
        nameNums.forEach((n) => {
          if (e.dutyDate === n.dutyDate) {
            if (names.includes(e.dutyDate)) {
              e.mergeCol = n.num;
              //删除已经设置过的值(防止被合并的单元格进到这个 if 语句中)
              names.splice(names.indexOf(n.dutyDate), 1);
            } else {
              //被合并的单元格设置为 0
              e.mergeCol = 0;
            }
          }
        });
      });
      //将整理后的数据交给表格渲染
      return data;
    },
    // 获取区县
    getCountyList() {
      this.$http.get('/api/getLowerLevelDepts?flag=3').then(res => {
        this.countyList = res.data
        this.countyId = res.data[0].indexCode
        this.getDutySignRecordss()
      })
    },
    getDutySignRecordss() {
      this.dataLoading = true
      if (!this.countyId) {
        this.countyId = this.countyList[0].indexCode
      }
      let params = {
        countyId: !this.countyId ? this.countyList[0].indexCode : this.countyId,
        yearAndMonth: this.dutyCalendarDate === '' ? null : this.$moment(this.dutyCalendarDate).format('YYYY-MM'),
        // page: this.currentPage,
        // size: this.pageSize
      }
      this.$http.post(`/api/getDutySignList?page=${this.currentPage}&size=${this.pageSize}`, params).then(res => {
        if (res.status === 200) {
          this.data =this.formatData( res.data.data)
          this.dataTotal = res.data.recordsTotal
          this.dataLoading = false
        }
      })
    },
    exportCalender() {
      this.exportLoading = true
      let params = {
        // status: '0',
        yearAndMonth: this.dutyCalendarDate === '' ? null : this.$moment(this.dutyCalendarDate).format('YYYY-MM'),
        // page: this.currentPage,
        // size: this.pageSize
      }
      this.$http.post('/api/export', params, {
        responseType: 'blob'
      }).then(res => {
        // console.log(res.data)
        if (res.status === 200) {
          const link = document.createElement('a')
          const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = `${this.$moment().format('yyyy-MM-DD')}-签到记录报表`
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
        } else {
          this.$message.warning('下载失败！')
        }
      }).catch(err => {
        console.log(err)
      }).finally(res => {
        this.exportLoading = false
      })
    },
    pageChange(page) {
      this.currentPage = page
      this.getDutySignRecordss()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getDutySignRecordss()
    },
  }
}
</script>

<style scoped>

</style>
